module.exports = __webpack_public_path__ + "static/media/icon-filter-lines-white.2db60bb1.svg";